import Vue from "vue";
import { ForbiddenException, HttpException, InternalServerErrorException } from "@/lib/exceptions/http";
import { NetworkError } from "@/lib/exceptions/http/NetworkError";
import ExceptionToastContent from "@/components/utility/ExceptionToastContent.vue";
import vuetify from "@/plugins/VuetifyPlugin";
import { $t } from "@/lib/utility/t";

/**
 * The toast for a request that got no response. A dropped connection fails every request at once; sharing one id, their
 * toasts replace each other instead of piling up.
 */
export const NETWORK_ERROR_TOAST_ID = "network-error";

export function toastException(error: HttpException, showMail = true) {
  Vue.$toast.error(
    Vue.extend({
      vuetify,
      render(createElement) {
        return createElement(ExceptionToastContent, { props: { error, showMail } });
      }
    })
  );
}
export function handleError(error: any) {
  Vue.$log?.error?.(error);
  if (error instanceof HttpException) {
    if (error instanceof InternalServerErrorException || error instanceof ForbiddenException) {
      toastException(error);
    } else {
      Vue.$toast.error(error.message);
    }
  } else if (error instanceof NetworkError) {
    // offline, blocked, timed out: the request never got an answer, which would otherwise fail without a word
    Vue.$toast.error($t("NetworkError"), { id: NETWORK_ERROR_TOAST_ID });
  }
}
